import styled from 'styled-components';

export const ProgressContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2rem 0;
  padding: 0 2rem;
`;

export const ProgressStep = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`;

export const ProgressLine = styled.div`
  width: 100px;
  height: 2px;
  background-color: ${props => props.isCompleted ? '#00C48C' : '#e0e0e0'};
  margin: 0 1rem;
  margin-top: -20px;
`;

export const StepIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${props => 
    props.isCompleted ? '#00C48C' : 
    props.isActive ? '#00C48C' : '#e0e0e0'
  };
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.5rem;
  transition: all 0.3s ease;
`;

export const StepLabel = styled.span`
  font-size: 12px;
  font-weight: ${props => props.isActive ? '600' : '400'};
  color: ${props => props.isActive ? '#00C48C' : '#666'};
  text-align: center;
  max-width: 120px;
  line-height: 1.2;
`;
